import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useGetStagesQuery } from "../../services/api";
import { setStage } from "../../store/reducers/stageReducer";
import { useAppDispatch, useAppSelector, RootState } from "../../store/store";
import Loader from "../../components/Loader";
import { ONBOARDING_STEPS } from "./steps";
import useHasPermission from "../../hooks/useHasPermission";

const Onboarding = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const stage = useAppSelector((state: RootState) => state.stage);
  const { hasPermission } = useHasPermission();

  const { data: stagesData, isLoading, isUninitialized } = useGetStagesQuery();

  const sortedSteps = [...ONBOARDING_STEPS].sort((a, b) => a.order - b.order);
  const currentStep = sortedSteps.find((step) => {
    const isCompleted = !!stage[step.key as keyof typeof stage];
    const isPermitted = !step.permissionKey || hasPermission(step.permissionKey);
    return !isCompleted && isPermitted;
  });
  //Need to remove this code after client a/b testing is complete
  const assignedFlow = useAppSelector((state) => state.login.assignedOnboardingFlow);
  useEffect(() => {
    if (stagesData?.data) {
      const flow = assignedFlow; 
      const processedStageData = {
        ...stagesData.data,
        billOfSaleSignedDate: stagesData.data.billOfSaleSignedDate
          ? new Date(stagesData.data.billOfSaleSignedDate)
          : null,
        presentationComplete: flow === "A" ? true : stagesData.data.presentationComplete
      };
      dispatch(setStage(processedStageData));
    }
  }, [stagesData, dispatch, assignedFlow]);
  //End a/b testing code

  // useEffect(() => {
  //   if (stagesData?.data) {
  //     dispatch(
  //       setStage({
  //         ...stagesData.data,
  //         billOfSaleSignedDate: stagesData.data.billOfSaleSignedDate
  //           ? new Date(stagesData.data.billOfSaleSignedDate)
  //           : null,
  //       }),
  //     );
  //   }
  // }, [stagesData, dispatch]);

  if (isLoading || isUninitialized) {
    return (
      <div className="h-dvh">
        <Loader isLoading={true} />
      </div>
    );
  }

  if (!currentStep) {
    return <Navigate to={`/dashboard/${id}`} replace />;
  }

  return currentStep.render();
};

export default Onboarding;
